/*
 * @Author: Hyman Choi
 * @Date: 2021-01-25 08:26:12
 * @LastEditTime: 2022-02-18 09:51:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\utils\config.js
 */
const config = {};

// 接口配置
config.API_ROOT = process.env.VUE_APP_BASE_API_ROOT;
config.API_LIVE = process.env.VUE_APP_BASE_API_LIVE;
config.API_TELEMEDICINE = process.env.VUE_APP_BASE_API_TELEMEDICINE;
config.API_AUTH = process.env.VUE_APP_BASE_API_AUTH;
config.API_MEDICAL = process.env.VUE_APP_BASE_API_MEDICAL;
config.API_MEDICAL1 = process.env.VUE_APP_BASE_API_MEDICAL1
config.API_ADMIN = process.env.VUE_APP_BASE_API_ADMIN;


// 图片地址
config.RESOURCES = process.env.VUE_APP_RESOURCES;
config.OSSBUCKET = process.env.VUE_APP_OSSBUCKET;
config.OSS_END_POINT = process.env.VUE_APP_OSS_ENDPOINT;

// 下载地址
config.APK = "https://pub.cloud.siui.com/App/Ultracloud_v1.1.0.apk";
config.IPA =
    "https://itunes.apple.com/CN/app/siui-%E9%BA%A6%E7%B2%92%E5%8C%BB%E7%94%9F/id1230334946?l=zh&ls=1&mt=8";


//config.show = process.env.	
//页面显示配置
//超人圈
config.SHOW_ULTRASONIC = process.env.VUE_APP_SHOW_ULTRASONIC
// 证件认证
config.SHOW_CERTIFICATION_MANAGEMENT = process.env.VUE_APP_SHOW_CERTIFICATION_MANAGEMENT
// 积分规则
config.SHOW_CREDIT_RULES = process.env.VUE_APP_SHOW_CREDIT_RULES
// 会诊
config.SHOW_DIAGNOSIS_MANAGEMENT = process.env.VUE_APP_SHOW_DIAGNOSIS_MANAGEMENT
config.SHOW_DIAGNOSIS_TAB = process.env.VUE_APP_SHOW_DIAGNOSIS_TAB
// 问答
config.SHOW_QUIZ_MANAGEMENT = process.env.VUE_APP_SHOW_QUIZ_MANAGEMENT
// 直播
config.SHOW_AUDIENCE_ROLE = process.env.VUE_APP_SHOW_AUDIENCE_ROLE
config.SHOW_VIRTUALLY_MEMBER = process.env.VUE_APP_SHOW_VIRTUALLY_MEMBER
// 是否显示UserDataType
config.SHOW_USER_DATA_TYPE = process.env.VUE_APP_SHOW_USER_DATA_TYPE
//文档管理，是否添加水印
config.SHOW_CS_FILE_WATERMARK_STATUS = process.env.VUE_APP_SHOW_CS_FILE_WATERMARK_STATUES
//是否显示产品用户认证tab
config.SHOW_USER_REVIEW_TAB = process.env.VUE_APP_SHOW_USER_REVIEW_TAB
//是否显示用户设备绑定tab（海外工业）
config.SHOW_USER_SERIES_TAB = process.env.VUE_APP_SHOW_USER_SERIES_TAB
//是否显示设备反馈tab（海外工业）
config.SHOW_DEVICE_FEEDBACK_TAB = process.env.VUE_APP_SHOW_DEVICE_FEEDBACK_TAB
//是否显示问题库管理tab（海外工业）
config.SHOW_DEVICE_QUESTION_TAB = process.env.VUE_APP_SHOW_DEVICE_QUESTION_TAB
//是否显示网盘相关服务（国内海外工业）
config.SHOW_NET_DISK_INFO = process.env.VUE_APP_SHOW_NET_DISK_INFO

config.OPEN_EDITOR = 0
export default config;
